import UserService from "@/services/user.service";
import { createToast } from "mosha-vue-toastify";
import i18n from "../lang";
import router from "../router";

export const user = {
	namespaced: true,
	state: {
		users: [],
		edit: {},
	},
	actions: {
		getUsers({ state }) {
			return UserService.getUsers().then((response) => {
				state.users = response.data;
			});
		},

		getUser({ state }, userId) {
			return UserService.getUser(userId).then((response) => {
				state.edit = response.data;
			});
		},

		deleteUser({ state }, userId) {
			return UserService.deleteUser(userId)
				.then(() => {
					state.users = state.users.filter(u => u.id !== userId);
					
					createToast(i18n.global.t("panel.users.userDeleted"), {
						type: "danger",
						position: "top-center",
					});
				})
				.catch((_error) => {
					createToast(i18n.global.t("panel.users.userDeleteError"), {
						type: "danger",
						position: "top-center",
					});
				});
		},

		setUserAsActive({ state }, data, route) {
			return UserService.updateUser(data.id, data)
				.then(() => {
					state.edit = data;

					router.push(route);
				})
				.catch((_error) => {
				});
		},

		updateUser({ state }, data) {
			return UserService.updateUser(data.id, data)
				.then(() => {
					state.edit = data;

					createToast(i18n.global.t("panel.users.userUpdated"), {
						type: "danger",
						position: "top-center",
					});

					router.push("/users");
				})
				.catch((_error) => {
					createToast(i18n.global.t("panel.users.userSaveError"), {
						type: "danger",
						position: "top-center",
					});
				});
		},

		createUser({ state }, data) {
			return UserService.createUser(data)
				.then(() => {
					state.edit = data;

					router.push("/users");
				})
				.catch((_error) => {
					createToast(i18n.global.t("panel.users.userSaveError"), {
						type: "danger",
						position: "top-center",
					});
				});
		},
	},
};
